import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals'

// Core Web Vitals -> GTM dataLayer (MKT-226). GTM is loaded via Segment, so
// window.dataLayer may not exist when a metric first fires; initializing it
// here lets GTM drain the queued pushes once its container loads. GTM adds page
// context and measurement maps the pushes to GA4 events, so no URLs or user
// identifiers belong here. web-vitals reports a metric more than once by design
// (CLS/INP refine on tab hide; bfcache restores re-report with a fresh id), so
// wv_metric_id is the dedup key the measurement side keys on — not a promise of
// a single push per metric.
const pushToDataLayer = ({ name, value, rating, id, navigationType }) => {
  try {
    window.dataLayer = window.dataLayer || []
    // dataLayer may be a third-party queue object that has not (yet) exposed a
    // push method; skip rather than risk a runtime error.
    if (typeof window.dataLayer.push !== 'function') {
      return
    }
    window.dataLayer.push({
      event: 'web_vitals',
      wv_metric_name: name,
      // CLS is a unitless score, encoded as an integer ×1000; others are ms
      wv_metric_value: Math.round(name === 'CLS' ? value * 1000 : value),
      wv_metric_rating: rating,
      wv_metric_id: id,
      wv_navigation_type: navigationType,
    })
  } catch {
    // analytics must never break the page
  }
}

export const initWebVitalsTracking = () => {
  try {
    onLCP(pushToDataLayer)
    onINP(pushToDataLayer)
    onCLS(pushToDataLayer)
    onTTFB(pushToDataLayer)
    onFCP(pushToDataLayer)
  } catch {
    // analytics must never break the page
  }
}
